module.exports = __webpack_public_path__ + "static/no-soy-bddfb8e3555e768107141e1475c1e27a.png";